export const LOG_SEVERITY = Object.freeze({
    DEBUG: 'debug',
    INFO: 'info',
    WARN: 'warn',
    ERROR: 'error',
});
export const LOG_TAGS = Object.freeze({
    INVALID_REGION: 'invalid-region',
    UPSELL_SEQUENCE_NOT_FOUND: 'upsell-sequence-not-found',
});
